export const LOCAL_STORAGE_KEYS = {
    EMPLOYEES: 'time_clock_employees',
    TIME_LOGS: 'time_clock_time_logs',
    LEAVE_ENTRIES: 'time_clock_leave_entries',
    PAYROLL_SETTINGS: 'time_clock_payroll_settings',
    OVERTIME_RULES: 'time_clock_overtime_rules',
    ACTIVITIES: 'time_clock_activities',
    DISPLAY_GROUPS: 'time_clock_display_groups',
    TIME_SETTINGS: 'time_clock_time_settings',
    LEAVE_CATEGORIES: 'time_clock_leave_categories',
    SELECTED_GROUP_ID: 'time_clock_selected_group_id',
    SHIFTS: 'time_clock_shifts',
    SCHEDULES: 'time_clock_schedules',
    COMPANY_SETTINGS: 'time_clock_company_settings',
    SCREENSAVER_SETTINGS: 'time_clock_screensaver_settings',
    SMTP_SETTINGS: 'time_clock_smtp_settings',
    NOTIFICATION_SETTINGS: 'time_clock_notification_settings',
    PINPAD_SIZE: 'time_clock_pinpad_size',
    GROUP_CONTENT_SIZES: 'time_clock_group_content_sizes',
} as const;